import React from "react";
import classNames from "classnames";
import "./index.scss";

import CheckBox from "../CheckBox";
import { getTranslateTitle } from '../../../utils/objects-util.js';

const SectionItemCheckBox = ({ item, column, value, onPropChange }) => (
  <div className={classNames("sectionItemCheckBox")}>
    <CheckBox id={item && item.id}
      disabled={column.isReadony}
      label={getTranslateTitle(column.title)}
      value={value || false}
      onChange={value => onPropChange({ [column.accessor]: value })}
    />
  </div>
);

export default SectionItemCheckBox;
